import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useRefresh } from 'react-admin';
import { LinkCallerDialog } from './LinkCallerDialog';
import { SourceRef } from './api';

type OpenLink = (source: SourceRef) => void;

const CallLinkContext = createContext<OpenLink | null>(null);

/**
 * Lets a call row in a feed offer "Link this call…" (T-189). Wrap a feed in it
 * and every PhoneEventBubble under it gets the action; feeds outside one (the
 * case file) don't show it.
 */
export function CallLinkProvider({
  children,
  onLinked,
}: {
  children: React.ReactNode;
  onLinked?: () => void;
}) {
  const refresh = useRefresh();
  const [source, setSource] = useState<SourceRef | null>(null);
  const openLink = useCallback<OpenLink>((s) => setSource(s), []);
  const value = useMemo(() => openLink, [openLink]);
  return (
    <CallLinkContext.Provider value={value}>
      {children}
      <LinkCallerDialog source={source} onClose={() => setSource(null)} onLinked={onLinked ?? refresh} />
    </CallLinkContext.Provider>
  );
}

/** Opens the dialog for a lead or one call; null outside a CallLinkProvider. */
export function useCallLink(): OpenLink | null {
  return useContext(CallLinkContext);
}
